/**
 * Utility functions to save and retrieve the previous URL path
 * for redirecting users after login/registration
 */

const REDIRECT_PATH_KEY = 'mc_redirect_path';

/**
 * Saves the current path to local storage for later redirection
 * @param path The path to save (without domain)
 */
export const saveRedirectPath = (path: string): void => {
  if (typeof window !== 'undefined') {
    try {
      // Don't save login or register paths
      if (path.includes('/account/login') || path.includes('/account/register')) {
        return;
      }
      
      // Don't save API paths
      if (path.includes('/api/')) {
        return;
      }
      
      localStorage.setItem(REDIRECT_PATH_KEY, path);
    } catch (error) {
      console.error('Failed to save redirect path to local storage:', error);
    }
  }
};

/**
 * Gets the saved redirect path from local storage
 * @returns The saved path or '/' if none exists
 */
export const getRedirectPath = (): string => {
  if (typeof window !== 'undefined') {
    try {
      const path = localStorage.getItem(REDIRECT_PATH_KEY);
      return path || '/';
    } catch (error) {
      console.error('Failed to get redirect path from local storage:', error);
    }
  }
  return '/';
};

/**
 * Clears the saved redirect path from local storage
 */
export const clearRedirectPath = (): void => {
  if (typeof window !== 'undefined') {
    try {
      localStorage.removeItem(REDIRECT_PATH_KEY);
    } catch (error) {
      console.error('Failed to clear redirect path from local storage:', error);
    }
  }
};

/**
 * Determines if the current path should be saved for redirection
 * @param path The current path
 * @returns True if the path should be saved, false otherwise
 */
export const shouldSavePath = (path: string): boolean => {
  // Don't save login or register paths
  if (path.includes('/account/login') || path.includes('/account/register')) {
    return false;
  }
  
  // Don't save API paths
  if (path.includes('/api/')) {
    return false;
  }
  
  return true;
};
